import { render } from "./BuySheetMusicLink.vue?vue&type=template&id=5403ca22&scoped=true"
import script from "./BuySheetMusicLink.vue?vue&type=script&lang=js"
export * from "./BuySheetMusicLink.vue?vue&type=script&lang=js"

import "./BuySheetMusicLink.vue?vue&type=style&index=0&id=5403ca22&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5403ca22"]])

export default __exports__